import React from "react";
 
import SetupProfile from "../SetupProfile";
import { useLocation } from 'react-router-dom';

const EditProfile = () => {
  
  const location = useLocation();

  const handleSubmit = () => {
    return;
  }

  return (
    <div className={"editContainer"}>
       
        <SetupProfile
          title={'Edit Profile'}
          submitBtnTitle={'Save changes'}
          handleSubmit={handleSubmit}
          displayLogo={false}
        />
    </div>
  );
}

export default EditProfile;
